import React, {memo} from "react";
// import Wrp from '../../../../hoc/Wrp/Wrp';
import { connect } from "react-redux";
import { isSet } from "../../../../Utils/CommonFunctions";
import SwitchItems from "../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
import DrillDown from "../../../../Components/DrillDown";
import SectionFormHeader from '../SectionTypeForm/SectionFormHeader';
import { updateLookupFieldDetails,setFormulaFieldDetails } from "../../../../store/actions/StepsFlowAction";
import Buttons from "../../../../Components/UI/Buttons";
import {ADDITIONAL_LAYOUT_FIELDS} from '../../../../Global/Constants';
import {getVariableDisplayValue} from '../../../../Containers/StepsFlowContainer/StepsFunction';

const StepsTypeForm = (props)=>{
  const {sectionIndex,isPopupWindow,modType,lookupFieldsData,reminderDisplayText} = props;
  const section  = JSON.parse(props.section);
  const sectionData = section.data;


  const updateValuesObjectHandler = (field,val)=>{
    //console.log('updateValuesObjectHandler field==',field,val)
    const {id,api_custom_field_name} = field;
    //api_custom_field_name
    const dispName = [];
    let selectedId = '';
    isSet(val,[]).map((dItem)=>{
        dispName.push(dItem.field_name);
        selectedId = dItem.id;
    });
    // console.log('dispName',dispName);
    const updateVal= (isSet(val,[]).length>0)?val[isSet(val,[]).length-1].window_field_id_path:'';
    let isLoop = isSet((isSet(val,[]).length>0)?isSet(isSet(val,[])[0].dependent_layout,{is_loop:false}).is_loop:false,false);
    let expression = [];
    let selectedValue = updateVal;
    if(isLoop===true){
        isSet(val,[]).map((expItm,expItmIndex)=>{
            if(expItmIndex===0 && expItm.dependent_layout.window_name){
                expression.push(expItm.dependent_layout.window_name)
            }
            if(isSet(expItm.api_field_name,null)!==null){
                expression.push(expItm.api_field_name);
            }
        })
        selectedValue=  '${'+expression.join('.')+'}';
    }
    const isVariableOrConstant = (isSet(val,[]).length>0)?
    isSet(isSet(val,[])[0].is_variable_or_constant,isSet(isSet(isSet(val,[])[0].dependent_layout,{is_variable_or_constant:false}).is_variable_or_constant,false))
        :false;
    if(isVariableOrConstant===true){
        selectedValue = selectedId;
    }   
    // console.log('selectedValue',selectedValue);
    
        const returnValue = [{
            name:dispName.join('.'),
            data_id:isSet((isSet(val,[]).length>0)?isSet(isSet(val,[])[0].dependent_layout,{data_id:null}).data_id:null,null),
            is_loop:isLoop,
            value:selectedValue,
            is_window_field:(isLoop===true && isVariableOrConstant===false)?true:false,
            is_variable_or_constant:isVariableOrConstant,
        }];
        if(ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(lookupFieldsData.lookupFields.field_name,'')) > -1){ // my code 07 - Notes, Tag api_key changes... 
            props.updateLookupFieldDetails(api_custom_field_name,returnValue);
        }else{
            props.updateLookupFieldDetails(id,returnValue);
        }
      }
  const removeHandler = (field)=>{
    const {id} = field;
    const returnValue = [{
        name:'',
        data_id:'',
        is_loop:false,
        value:'',
        is_window_field:false,
        is_variable_or_constant:false,
    }];
    props.updateLookupFieldDetails(id,returnValue); 
  }
  const updateValueHandler = (field,e,type='TextInput')=>{
        //console.log('updateValueHandler==',field,e,type)
        const {id,api_custom_field_name} = field;
        console.log('updateValueHandler==',id,api_custom_field_name)
        let fieldValue = null;
        let displayName = null;
        if(type==='MultiSelect'){
            let MultiSelectValue = [];
            e = (e===null)?[]:e;
            e.map((item)=>{
                MultiSelectValue.push(item.id);
                    return item;
            }); 
            fieldValue = MultiSelectValue.join(',');
        }else if(type==='CheckBoxes'){
            fieldValue = e.target.checked;
        }else if(type==='date'){
            fieldValue = isSet(e,'');
        }else if(['number','phoneNumber','PickList'].indexOf(type)!==-1){
            fieldValue = e
        }else if(['Lookup','MultiLookup'].indexOf(type)!==-1){
            fieldValue = e.selectedValue;
            displayName = e.displayValue;
            // console.log('e',e);
        }else if(type==='Files'){
            fieldValue = e;
        }else if(type==='Reminder'){
            fieldValue = e;
        }else{ 
            fieldValue = e.target.value;
        }
        const returnValue = [{
            name:'',
            data_id:'',
            is_loop:false,
            value:fieldValue,
            is_window_field:false,
            is_variable_or_constant:false,
        }]
        //console.log('returnValue==',returnValue)
        if(ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(lookupFieldsData.lookupFields.field_name,'')) > -1 || ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(lookupFieldsData.lookupFields.field_type,'')) > -1){ // my code 07 - Notes, Tag, Picklist, Multiselect api_key changes... 
            props.updateLookupFieldDetails(api_custom_field_name,returnValue);
        }else{
            props.updateLookupFieldDetails(id,returnValue);
        }
  }


  const updateValuesObjectHandlerForFormula = (id,val) => {
        let returnValue = [{...val}]
        props.updateLookupFieldDetails(id,returnValue)
  }

  //console.log('lookupFieldsData===',lookupFieldsData)

  return(
    <div className="col-12 mb-2" key={sectionIndex}>
    <div className="card-outer">
        <SectionFormHeader title={section.title} secId={section.id} isQuickCreate={props.isQuickCreate} />
         <div className={`form-body pt-2 p-2 show`} id={section.id}>
             <div className="row" key={"forms"+sectionIndex}>
                 {sectionData.map((item,itemIndex)=>{
                   const fieldObj = {
                     section_index:section.section_index,
                     sectionId:section.id,
                     itemIndex:item.itemIndex,
                     isSteps:true,
                     modType:modType,
                     item:{
                      ...item,
                      modType:modType
                    },
                  }
                  if(item.element==='MultiLookup' || item.element==='Lookup'){
                    return false;
                  }
                  let updateItem = {...item,modType:modType};
                  let editHandler = ()=>{}

                  let myArrayConst = props.valuesObject[item.id];
                  //console.log('myArrayConst==',myArrayConst)
                  let getVal = '';
                  let selectedValueForDrill = null;
                  if(ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(lookupFieldsData.lookupFields.field_name,'')) > -1 || ADDITIONAL_LAYOUT_FIELDS.indexOf(isSet(lookupFieldsData.lookupFields.field_type,'')) > -1){ // my code 07 - Notes, Tag api_key changes...     
                    console.log('props.valuesObject==',props.valuesObject)                    
                    myArrayConst = props.valuesObject[item.api_custom_field_name];
                    if(myArrayConst === undefined){
                        myArrayConst = props.valuesObject[item.id]; 
                    }
                    }

                  try{
                    let selectedValue = item.selectedValue;
                    let elementType = item.element;
                    let isEditEnable = false;
                    if(isSet(myArrayConst[0].is_loop,false)===true || isSet(myArrayConst[0].is_variable_or_constant,false)===true){
                        selectedValue = isSet(myArrayConst[0].name,null);
                        elementType = 'StepsTypeTag';
                    }else if(isSet(myArrayConst[0].is_expression,false)===true){
                        selectedValue = isSet(myArrayConst[0].name,null);
                        elementType = 'StepsTypeTag';
                        isEditEnable = true;
                        editHandler = ()=>props.setFormulaFieldDetails({
                                    value:(isSet(myArrayConst,[]).length)>0?isSet(myArrayConst[0],{}).value:'',
                                    conValue:isSet(myArrayConst,[{
                                        name:'',
                                        data_id:'',
                                        is_loop:false,
                                        value:'',
                                        is_window_field:false,
                                        is_variable_or_constant:false,
                                        is_expression:true
                                    }]),
                                    itmValIndex:0,
                                    drillDownOptions:lookupFieldsData.lookupFields.drillDownOptions,
                                    //updateVariables:(itmIndex,key,val)=>props.updateLookupFieldDetails(item.id,val),
                                    updateValuesChangeHandler:(val)=>updateValuesObjectHandlerForFormula(item.id,val),
                                    conIndex:0,
                                },true)
                    }
                    else if(isSet(myArrayConst[0].is_loop,false)===false || isSet(myArrayConst[0].is_variable_or_constant,false)===false){
                        selectedValue = isSet(myArrayConst[0].value,null)
                    }

                    updateItem = {
                        ...updateItem,
                        element:elementType,
                        isEditEnable:isEditEnable,
                        editHandler:editHandler,
                        removeHandler:removeHandler,
                        selectedValue:selectedValue,//isSet(props.valuesObject[item.id][0].name,null),
                        reminder:isSet(myArrayConst[0].value,''),
                    }
                    //console.log('selectedValue Section==',selectedValue)

                    getVal = (isSet(myArrayConst,[]).length)>0?isSet(myArrayConst[0],{}).value:''
                    selectedValueForDrill = getVariableDisplayValue(lookupFieldsData.lookupFields.drillDownOptions,getVal,{});
                      
                  }catch(e){
                    // console.log('exc',e);
                  }
                  const btnGroup = [{ 
                    isButtonGroup:true,
                    className:'input-group-text pl-2 pr-2',
                    style:{},
                    list:[
                    {
                        href:"",
                        attributes:{
                        className:"border-default dropdown-toggle  dropdown-menu-right hidden-caret",
                        'data-toggle':'dropdown',
                        'aria-expanded':'false'
                        },
                        name:"",
                        svgIcon:'EllipsisV',
                        children:{
                            attributes:{
                            className:"dropdown-menu dropdown-menu-right"
                            },
                            style:{
                            position:'absolute',
                            transform: 'translate3d(-44px, 33px, 0px)', 
                            top: '0px',
                            left: '0px', 
                            willChange: 'transform'
                            },
                            buttonList:[{
                                name:'Add Formula',
                                attributes:{
                                    className:'dropdown-item'
                                },
                                clickHandler:()=>props.setFormulaFieldDetails({
                                    value:(isSet(myArrayConst,[]).length)>0?isSet(myArrayConst[0],{}).value:'',
                                    conValue:isSet(myArrayConst,[{
                                        name:'',
                                        data_id:'',
                                        is_loop:false,
                                        value:'',
                                        is_window_field:false,
                                        is_variable_or_constant:false,
                                        is_expression:true
                                    }]),
                                    itmValIndex:0,
                                    drillDownOptions:lookupFieldsData.lookupFields.drillDownOptions,
                                    //updateValuesChangeHandler:(itmIndex,key,val)=>{console.log('val',val); props.updateLookupFieldDetails(item.id,val)},
                                    //updateValuesChangeHandler:(val)=>props.updateLookupFieldDetails(item.id,val),
                                    updateValuesChangeHandler:(val)=>updateValuesObjectHandlerForFormula(item.id,val),
                                    conIndex:0,
                                },true)
                            }]
                            }
                        }
                    ]
                }]

                updateItem = {
                    ...updateItem,                    
                    lookupFieldsData:lookupFieldsData,
                    updateValuesObjectHandler:updateValuesObjectHandler,
                    btnGroup:btnGroup,
                }
                 //console.log('updateItem==',updateItem)                 
                 //console.log('selectedValueForDrill==',selectedValueForDrill)
                  return(
                    <>
                    <SwitchItems 
                        key={itemIndex}
                        item={updateItem}
                        section={section}
                        fieldObj={fieldObj}
                        isPopupWindow={isPopupWindow}
                        layoutForms={true} 
                        reminderDisplayText={reminderDisplayText}
                        screen="Steps"
                        formType="STEPS"
                        appendBlocks={(item.element==='CheckBoxes' || item.element==='ImageUpload' || item.element==='FileUpload' || item.element==='Reminder' || item.element==='PickList'|| item.element==='MultiSelect')?
                        <></>:
                        <div className='input-group-append cursor-pointer'>
                             <DrillDown 
                                drillId={"drill_"+item.id} 
                                selectedValue={isSet(selectedValueForDrill,[]).length>0?selectedValueForDrill:[]} 
                                hocClass='input-group-text'
                                fieldDetails={lookupFieldsData.lookupFields.drillDownOptions} 
                                selectHandler={(val)=>updateValuesObjectHandler(item,val)}
                                isConditionApplied={true}
                                isCustomChildren={true} >
                            <span className="input-group-text" style={{height:'100%',display:'block',border:'0px'}}>
                                <i className="fas fa-search primary_color"></i>
                            </span>
                            </DrillDown>
                            <Buttons buttonList={btnGroup} />
                        </div>
                        }
                        {...props} 
                        onChangeInputAction={(obj,val,type)=>{
                            props.onChangeInputAction(obj,val,type);
                            updateValueHandler(item,val,type);
                        }}/>
                    </>
                  )
                 })}
             </div>
         </div>
         </div>
     </div>
  )
};
const mapStateToProps = (state,props) => { 
    return {
        lookupFieldsData:state.StepsFlowReducer.lookupFieldsData,
        valuesObject:state.StepsFlowReducer.lookupFieldsData.valuesObject,
        //  formulaFieldData:state.StepsFlowReducer.formulaFieldData
    };
  }

const mapDispatchToProps = dispatch => {
    return {
      setFormulaFieldDetails:(obj,bool)=>dispatch(setFormulaFieldDetails(obj,bool)),
      updateLookupFieldDetails:(obj,val)=>dispatch(updateLookupFieldDetails(obj,val)),
    };
}
export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(memo(StepsTypeForm));

